import React, { useState } from 'react';

export default function ConnectUs() {
  // State to manage form data
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    reason: '',
    phone: '',
    message: ''
  });

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    // Construct the WhatsApp message with form data
    const message = `
      New Contact Form Submission:
      Name: ${formData.name}
      Email: ${formData.email}
      Reason for Contacting: ${formData.reason}
      Phone: ${formData.phone || 'Not provided'}
      Message: ${formData.message || 'No message provided'}
    `.trim();

    // Encode the message for the URL
    const encodedMessage = encodeURIComponent(message);

    // WhatsApp URL for the phone number +97125868431
    const whatsappUrl = `https://wa.me/+97125868431?text=${encodedMessage}`;

    // Open WhatsApp chat in a new tab/window
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="bg-gray-100 py-10 px-6 md:px-16">
      <div className="max-w-4xl mx-auto rounded-lg md:p-8">
        {/* Heading Section */}
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-indigo-900">
            What can we do for you?
          </h2>
          <p className="text-indigo-900 mt-2">
            We are ready to work on a project of any complexity, whether it's
            commercial or residential.
          </p>
        </div>

        {/* Form Section */}
        <form className="space-y-6" onSubmit={handleSubmit}>
          {/* Input Fields (Responsive Grid) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name*"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email*"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="text"
              name="reason"
              placeholder="Reason for Contacting*"
              value={formData.reason}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Textarea */}
          <textarea
            name="message"
            placeholder="Message"
            rows="4"
            value={formData.message}
            onChange={handleChange}
            className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>

          {/* Note */}
          <p className="text-sm text-gray-500">
            <span className="text-red-500">*</span> indicates a required field
          </p>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full md:w-auto px-20 py-2 bg-indigo-900 text-white hover:bg-blue-800 transition"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
}